/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Transcript_TitleInputs */



/**
* | output |
* | --- |
* | "Transcript" |
*
* @param {File_Export_Transcript_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_transcript_title = /** @type {((inputs?: File_Export_Transcript_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Transcript_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkript")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стенограмма")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文字稿")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलिपि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcrição")
	return /** @type {LocalizedString} */ ("Transcript")
});